import { Address } from "./address.model";
import { DebtorAccount } from "./debtor-account.model";
import { Phone } from "./phone.model";
import * as _ from 'lodash';

export class Debtor {
    constructor() {
        this.debtorId = 0;
        this.totalDebt = 0;
        this.totalCosts = 0;
        this.totalInterest = 0;
        this.totalPaid = 0;
        this.totalOutstanding = 0;
        this.firstname = "";
        this.companySurname = "";
        this.postalAddress = {} as Address;
        this.email = "";
        this.phoneNumbers = [];
        this.arrangementDetails = [];
        this.debtorAccounts = [];
    }

    debtorId: number;
    totalDebt: number;
    totalCosts: number;
    totalInterest: number;
    totalPaid: number;
    totalOutstanding: number;
    firstname: string;
    companySurname: string;
    postalAddress: Address;
    email: string;
    phoneNumbers: Array<Phone>;
    arrangementDetails: Array<any>;
    debtorAccounts: Array<DebtorAccount>;

    public getName(): string {
        let result = '';

        if (!_.isNil(this.firstname)) {
        result += this.firstname;
        }

        if (!_.isNil(this.companySurname)) {
        if (result !== '') {
            result += ' ';
        }

        result += this.companySurname;
        }
    
        return result;
      }
}
